<!-- eslint-disable vue/no-template-shadow -->
<template>
  <div>
    <div class="text-black">
      <BCol
        md="12"
        class="d-flex gap-10 w-100 p-0 my-[24px]"
      >
        <b-dropdown
          id="dropdown-1"
          class="filter"
          no-caret
          variant="primary"
          toggle-class="text-decoration-none toggle-custom button-primary rounded-lg py-0 px-1"
        >
          <h5>Filter</h5>
          <template #button-content>
            <b-img
              src="https://storage.googleapis.com/komerce/assets/komerce-icon/Putih/filter-search.svg"
              class="height-[20px]"
            />
          </template>
          <b-dropdown
            id="dropdown-2"
            class="w-100"
            toggle-class="text-left"
            variant="none"
            left
            no-caret
            dropright
            menu-class="overflow-y-auto h-[300px]"
          >
            <template #button-content>
              <span class="hover-salmon text-6 w-100">Skill role</span>
            </template>
            <b-dropdown-form style="width: 200px">
              <b-form-checkbox
                v-for="(skill, index) in listSkills"
                :key="index"
                v-model="filterSelected"
                :name="`checkbox-${index}`"
                class="text-6 mb-1"
                :value="skill.id"
                @change="getListTalent()"
              >
                {{ skill.name }}
              </b-form-checkbox>
            </b-dropdown-form>
          </b-dropdown>
          <b-dropdown
            id="dropdown-3"
            class="w-100"
            toggle-class="text-left"
            variant="none"
            left
            no-caret
            dropright
          >
            <template #button-content>
              <span class="hover-salmon text-6 w-100">Pendidikan</span>
            </template>
            <b-dropdown-form style="width: 200px">
              <b-form-checkbox
                v-for="(education, index) in filterEducationOptions"
                :key="index"
                v-model="filterEducationSelected"
                :name="`checkbox-${index}`"
                class="text-6 mb-1"
                :value="education.value"
                @change="getListTalent()"
              >
                {{ education.text }}
              </b-form-checkbox>
            </b-dropdown-form>
          </b-dropdown>
          <b-dropdown
            id="dropdown-4"
            class="w-100"
            toggle-class="text-left"
            variant="none"
            left
            no-caret
            dropright
          >
            <template #button-content>
              <span class="hover-salmon text-6 w-100">Pengalaman Kerja</span>
            </template>
            <b-dropdown-form style="width: 200px">
              <b-form-checkbox
                v-for="(experience, index) in filterExperienceOptions"
                :key="index"
                v-model="filterExperienceSelected"
                :name="`checkbox-${index}`"
                class="text-6 mb-1"
                :value="experience.value"
                @change="getListTalent()"
              >
                {{ experience.text }}
              </b-form-checkbox>
            </b-dropdown-form>
          </b-dropdown>
          <h5
            class="pb-0 pt-1 font-bold text-danger w-100 cursor-pointer"
            @click="resetFilter()"
          >
            Reset filter
          </h5>
        </b-dropdown>
        <div class="d-flex rounded-lg align-items-center border search-bar">
          <span
            class="k-search-normal-1 h-100 font-bold text-10 pt-[7px] align-middle mx-[5px]"
          />
          <BFormInput
            v-model="keyword"
            placeholder="Cari Nama"
            class="border-0"
            @input="handleSearch()"
          />
        </div>
        <BButton
          tag="router-link"
          to="/talent/create"
          variant="primary"
          class="ml-auto px-3"
        >
          <strong>Tambah</strong>
        </BButton>
      </BCol>
    </div>
    <BOverlay
      id="scroll"
      :show="loading"
      spinner-variant="primary"
      variant="light"
      blur="0"
      opacity=".5"
      rounded="sm"
    >
      <div
        id="table"
        style="height: calc(100vh - 340px); overflow-y: scroll;"
        @scroll="handleScroll"
      >
        <BTable
          :items="items"
          :fields="fields"
          empty-text="Tidak ada data yang ditampilkan."
          responsive
          show-empty
        >
          <template #cell(name)="data">
            <div class="flex items-center">
              <img
                v-if="data.item.photo_profile_url === ''"
                src="https://storage.googleapis.com/komerce/assets/avatars/image-null.png"
                alt="Komerce"
                class="w-[40px] h-[40px] rounded-circle"
              >
              <img
                v-else
                :src="data.item.photo_profile_url"
                onerror="this.onerror=null;this.src='https://storage.googleapis.com/komerce/assets/avatars/image-null.png';"
                alt="Komerce"
                class="w-[40px] h-[40px] rounded-circle object-fit-cover"
              >
              <div class="ml-1">
                {{ data.item.full_name }}
              </div>
            </div>
          </template>
          <template #cell(year_experience)="data">
            <span>
              {{ data.item.year_experience || '-' }}
            </span>
          </template>
          <template #cell(status)="data">
            <span class="selected">
              {{ data.item.status }}
            </span>
          </template>
          <template #cell(quiz)>
            <BButton
              size="md"
              variant="outline-primary"
            >
              Lihat
            </BButton>
          </template>
          <template #cell(action)="data">
            <div class="flex justify-end items-center">
              <BButton
                class="btn-icon mr-50"
                size="sm"
                variant="flat-warning"
                :to="{
                  name: $route.meta.routeEdit,
                  params: { id: data.item.id }
                }"
                tag="router-link"
              >
                <img
                  src="https://storage.googleapis.com/komerce/assets/komerce-icon/Orange/edit.svg"
                  alt="Komerce"
                  class="mr-[5px]"
                >
              </BButton>
              <BButton
                class="btn-icon mr-50"
                size="sm"
                variant="flat-warning"
              >
                <img
                  v-b-modal.modalDelete
                  src="https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/trash.svg"
                  alt="Komerce"
                  @click="selectItem(data.item.id)"
                >
              </BButton>
            </div>
          </template>
        </BTable>
      </div>
    </BOverlay>
    <ModalDelete
      :id-item="idItem"
      @deleted="getListTalent()"
    />
  </div>
</template>

<script>
import { komtimAxiosIns } from '@/libs/axios'
import { alertError } from '@toast'
import { tableSelected } from '../config'
import ModalDelete from '../ModalDelete.vue'

export default {
  components: {
    ModalDelete,
  },
  data() {
    return {
      loading: false,
      items: [],
      limit: 20,
      offset: 0,
      lastData: false,
      keyword: '',
      fields: tableSelected,
      idItem: 0,
      filterSelected: [],
      filterEducationSelected: [],
      filterExperienceSelected: [],
      listSkills: [],
      alertError,
      filterEducationOptions: [
        { text: 'SD', value: 'SD' },
        { text: 'SMP', value: 'SMP' },
        { text: 'SMA/SMK', value: 'SMA' },
        { text: 'Sarjana', value: 'Sarjana' },
      ],
      filterExperienceOptions: [
        { text: '< 1 Tahun', value: '< 1 year' },
        { text: '1 Tahun', value: '1 year' },
        { text: '2 Tahun', value: '2 years' },
        { text: '3 Tahun', value: '3 years' },
        { text: 'Tidak Ada', value: 'nothing' },
      ],
    }
  },
  computed: {
    skill() { return this.filterSelected.join(',') },
    education() { return this.filterEducationSelected.join(',') },
    experience() { return this.filterExperienceSelected.join(',') },
  },
  mounted() {
    this.getListTalent()
    this.getListSkills()
  },
  methods: {
    handleScroll() {
      const table = document.getElementById('table')
      if ((table.scrollTop >= table.scrollHeight - table.offsetHeight) && !this.loading && !this.lastData) {
        this.getNextData()
      }
    },
    async getListTalent() {
      this.loading = true
      this.offset = 0
      const params = `offset=${this.offset}&limit=${this.limit}&status=selected&skill=${this.skill}&education=${this.education}&year_experience=${this.experience}&keyword=${this.keyword}&mode=display`
      const url = `v1/talents?${params}`
      await komtimAxiosIns
        .get(url)
        .then(res => {
          this.loading = false
          const { data, meta } = res.data
          this.items = data
          this.offset = data?.length
          this.$emit('updateTotal', meta.total)

          if (data?.length < this.limit) {
            this.lastData = true
          } else {
            this.lastData = false
          }
        })
        .catch(err => {
          this.loading = false
          this.alertError(err)
        })
    },
    async getNextData() {
      this.loading = true
      if (!this.lastData) {
        const params = `offset=${this.offset}&limit=${this.limit}&status=selected&skill=${this.skill}&education=${this.education}&year_experience=${this.experience}&keyword=${this.keyword}&mode=display`
        const url = `v1/talents?${params}`

        await komtimAxiosIns.get(url)
          .then(res => {
            const { data } = res.data
            this.items.push(...data)
            this.offset += data.length
            this.loading = false
            if (data.length < this.limit) {
              this.lastData = true
            }
          })
          .catch(err => {
            this.alertError(err)
          })
      }
    },
    handleSearch: _.debounce(function search() {
      this.getListTalent()
    }, 1000),
    selectItem(id) {
      this.idItem = id
    },
    async getListSkills() {
      this.loading = true
      this.offset = 0
      const params = `active=${true}&type=2`
      const url = `v1/skills/resource?${params}`

      await komtimAxiosIns
        .get(url)
        .then(res => {
          this.loading = false
          const { data } = res.data
          this.listSkills = data
        })
        .catch(err => {
          this.alertError(err)
          this.loading = false
        })
    },
    resetFilter() {
      this.filterSelected = []
      this.filterEducationSelected = []
      this.filterExperienceSelected = []
      this.getListTalent()
    },
  },

}
</script>
<style scoped lang="scss">
@import '../style/Registered.scss';

.selected {
  background: #DCF3EB;
  border-radius: 4px;
  color: #34A770;
  font-weight: 500;
  font-size: 14px;
  padding: 3px 10px;
  width: 100%;
}
</style>
